import React from 'react'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'

const LoaderContainer = styled.div`
  display: flex;
  gap: ${rem(8)};

  ${mediaQueryDown.mobile} {
    min-height: ${rem(100)};
    overflow: hidden;
    border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
    border-radius: ${rem(8)};
  }

  ${mediaQueryUp.tablet} {
    display: grid;
    grid-template-rows: min-content 1fr;
    gap: 0;
    min-height: ${rem(400)};
  }
`

const ImageBox = styled(LoadingBox)`
  width: ${rem(90)};
  flex-shrink: 0;
  border-radius: 0;

  ${mediaQueryUp.tablet} {
    width: 100%;
    height: ${rem(162)};
    border-radius: 0;
  }
`

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  padding-block: ${rem(4)};
  padding-inline: 0 ${rem(8)};

  ${mediaQueryDown.mobile} {
    justify-content: space-between;
    padding-block: ${rem(2)};
  }

  ${mediaQueryUp.tablet} {
    justify-content: space-between;
    padding: ${rem(12)};
  }
`

const UrgencyLabelLoadingBox = styled(LoadingBox)`
  height: ${rem(24)};
  width: ${rem(72)};
  border-radius: ${(props) => props.theme.borderRadius.S};

  ${mediaQueryDown.mobile} {
    display: none;
  }
`

const PriceCaptionLoadingBox = styled(TextLoadingBox)`
  ${mediaQueryDown.mobile} {
    display: none;
  }
`

const MobileRatingLoadingBox = styled(LoadingBox)`
  display: none;

  ${mediaQueryDown.mobile} {
    display: block;
    width: ${rem(32)};
    height: ${rem(20)};
    border-radius: ${(props) => props.theme.borderRadius.S};
    transform: translateY(-${rem(4)});
  }
`

const Footer = styled.div`
  margin-top: ${rem(8)};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  ${mediaQueryDown.mobile} {
    align-items: flex-end;
    justify-content: space-between;
  }
`

const PriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
`

interface Props {
  className?: string;
}

function ExperienceCompactSearchTileSkeleton(props: Props) {
  return (
    <LoaderContainer className={props.className}>
      <ImageBox />
      <Content>
        <div>
          <VerticalSpacer gap={8}>
            <UrgencyLabelLoadingBox />
            <div>
              <TextLoadingBox typography="body-small" width={96} />
              <TextLoadingBox typography="caption-large" width="100%" />
              <TextLoadingBox typography="caption-large" width={148} />
            </div>
          </VerticalSpacer>
        </div>
        <Footer>
          <div>
            <PriceCaptionLoadingBox typography="caption-large" width={28} />
            <PriceRow>
              <TextLoadingBox typography="heading6" width={92} />
            </PriceRow>
          </div>
          <MobileRatingLoadingBox />
        </Footer>
      </Content>
    </LoaderContainer>
  )
}

export default ExperienceCompactSearchTileSkeleton
